// extracted by mini-css-extract-plugin
export default {"tabs-header":"TabSelect_tabs-header__f79n2","tabs-icon-menu":"TabSelect_tabs-icon-menu__lRmWz","tabs-body":"TabSelect_tabs-body__jCnfq"};